<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="15" height="15" stroke="currentColor" />
    <path d="M10 2V17.5" stroke="currentColor" />
    <path d="M2.5 13.5L6 10L10 14" stroke="currentColor" />
    <circle cx="7" cy="6" r="1" fill="currentColor" />
    <path d="M13.5 2.5L10 6" stroke="currentColor" />
    <path d="M10 11L17.5 3.5M10 16L17.5 8.5M14 17.5L17.5 14" stroke="currentColor" />
  </svg>
</template>
